import { cryptocurrencies, NetworkKey } from "@/lib/constants/cryptos";

export type Token = {
  id: string;
  tokenAddress: string;
  symbol: string;
  name: string;
  decimals: string;
  balance: string;
  balanceFormatted: string;
  chain: NetworkKey;
  nativeToken?: boolean;
  platforms?: string[];
  price?: number;
  change?: number;
  cap?: number;
};

abstract class BaseNetwork {
  network: NetworkKey;

  address: string;

  name: string;
  symbol: string;

  constructor(network: NetworkKey, xpub: string) {
    this.network = network;

    const cryptoInfo = cryptocurrencies[network];

    this.name = cryptoInfo.name;
    this.symbol = cryptoInfo.symbol;

    this.address = this.getAddress(0, cryptoInfo.derivationPath, xpub);
  }

  abstract getAddress(
    index: number,
    derivationPath: number[],
    signatureAlgorithm: string,
  ): string;
}

export default BaseNetwork;
